import { AxiosResponse } from "axios";
import { Requests } from "../../config/api";
import { getRequest } from "../commonActions/get";
import { postRequest } from "../commonActions/post";
import {
  CreatePackageProps,
  CreatePackageReturnType,
  GetPackageCategoriesProps,
  GetPackageCategoriesReturnType,
} from "../../declarations/tourServices";
import { PlatformFee } from "../../declarations/platformFee";
import { patchRequest, putRequest } from "../commonActions/update";
import { deleteRequest } from "../commonActions/delete";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";

export const GetPackageCategories = async ({
  setLoading,
}: GetPackageCategoriesProps): Promise<GetPackageCategoriesReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getPackageCategories,
    });
    setLoading && setLoading(false);

    const categories = response?.data?.categories;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      categories,
      errors,
      message: message,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const CreatePackage = async ({
  setLoading,
  payload,
}: CreatePackageProps): Promise<CreatePackageReturnType> => {
  try {
    console.log("payload", payload);
    setLoading && setLoading(true);

    // Send as JSON, not FormData
    const response: AxiosResponse = await postRequest({
      route: Requests.post.createPackage,
      payload, // send plain object
    });

    setLoading && setLoading(false);

    const packageData = response?.data?.package;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;

    return {
      status,
      packageData: packageData ? [packageData] : [],
      errors,
      message,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const CreatePrePackage = async ({
  setLoading,
  payload,
}: CreatePackageProps): Promise<CreatePackageReturnType> => {
  console.log("prepacklast", payload);
  try {
    let payloadId: any = payload._id;
    if (!payloadId) {
      delete payload._id;
    }
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === "object" && item !== null) {
            formData.append(`${key}[${index}]`, JSON.stringify(item));
          } else {
            formData.append(`${key}[${index}]`, item as string);
          }
        });
      } else if (typeof value === "object" && value !== null) {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value as string);
      }
    });

    setLoading && setLoading(true);
    const response: AxiosResponse = await postRequest({
      route: Requests.post.createPrePackage,
      payload: formData,
    });

    setLoading && setLoading(false);

    const packageData = response?.data?.prePackage;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;

    return {
      status,
      packageData: packageData ? [packageData] : [],
      errors,
      message,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const CreatePrePackageJson = async ({
  setLoading,
  payload,
}: CreatePackageProps): Promise<CreatePackageReturnType> => {
  console.log("prepacklast", payload);

  try {
    // Remove _id if it's undefined
    let payloadId: any = payload._id;
    if (!payloadId) {
      delete payload._id;
    }

    setLoading && setLoading(true);

    // Send as JSON instead of FormData
    const response: AxiosResponse = await postRequest({
      route: Requests.post.createPrePackage,
      payload: payload,
    });

    setLoading && setLoading(false);

    const packageData = response?.data?.prePackage;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;

    return {
      status,
      packageData: packageData ? [packageData] : [],
      errors,
      message,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetPrePackage = async ({
  setLoading,
}: CreatePackageProps): Promise<any> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getPrePackage}?skip=1&limit=10`,
    });
    setLoading && setLoading(false);

    console.log("get pre package data", response);

    const prePackages = response?.data?.prePackages;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      prePackages,
      errors,
      message: message,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetPackageById = async ({
  setLoading,
  id,
}: {
  setLoading: (loading: boolean) => void;
  id: string;
}): Promise<any> => {
  try {
    setLoading && setLoading(true);

    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getPackageById}${id}`,
    });

    setLoading && setLoading(false);

    console.log("myre", response.data.prePackage);

    const packageresponse = response?.data?.prePackage;
    const success = response?.data?.success;

    return {
      success,
      packageresponse,
    };
  } catch (error) {
    setLoading && setLoading(false);
    console.error("Error in GetPackageById:", error);
    throw error;
  }
};

export const GetPackagesById = async ({
  setLoading,
  id,
}: {
  setLoading: (loading: boolean) => void;
  id: string;
}): Promise<any> => {
  try {
    setLoading && setLoading(true);

    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getPackagesById}${id}`,
    });

    setLoading && setLoading(false);

    console.log("myre", response.data.package);

    const packageData = response?.data?.package;
    const message = response?.data?.message;
    const errors = response?.data?.message;
    const success = response?.data?.success;

    return {
      success,
      errors,
      message,
      packageData,
    };
  } catch (error) {
    setLoading && setLoading(false);
    console.error("Error in GetPackageById:", error);
    throw error;
  }
};

export const GetPlatformFee = async ({ setLoading }: any): Promise<any> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.platformFee,
    });
    setLoading && setLoading(false);

    console.log("feeres", response);
    const status = response?.status;
    const value = response?.data.value;
    const type = response?.data.type;

    return {
      status: status,
      value,
      type,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetPackage = async (query: any) => {
  console.log("query");
  try {
    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getPackage}?searchKey=${query}`,
    });

    console.log("myre", response);

    const packages = response?.data?.packages;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      packages,
      errors,
      message: message,
    };
  } catch (error) {
    throw error;
  }
};

export const GetOptions = async (query: any) => {
  console.log("query");
  try {
    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.getOption}?searchKey=${query}`,
    });

    console.log("myre", response);

    const options = response?.data?.options;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      options,
      errors,
      message: message,
    };
  } catch (error) {
    throw error;
  }
};

export const GetPackageData = async () => {
  console.log("query");
  try {
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getPackage,
    });

    const packages = response?.data?.packages;
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      packages,
      errors,
      message: message,
    };
  } catch (error) {
    throw error;
  }
};

export const ApprovePackage = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await patchRequest({
      route: `${Requests.update.approvePackage}/${id}`,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const RejectPackage = async (id: string, payload: any): Promise<any> => {
  try {
    const response: AxiosResponse = await patchRequest({
      route: `${Requests.update.rejectPackage}/${id}`,
      payload,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const DeletePackage = async (id: string): Promise<any> => {
  try {
    const response: AxiosResponse = await deleteRequest({
      route: `${Requests.delete.deletePackage}/${id}`,
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdatePackage = async ({
  id,
  payload,
}: {
  id: string;
  payload: any;
}): Promise<any> => {
  try {
    const response: AxiosResponse = await putRequest({
      route: `${Requests.update.updatePackage}${id}`,
      payload: payload,
    });

    const status = response?.status;
    const errors = response?.data?.errors;
    const message = response?.data?.message;

    return {
      status,
      errors,
      message,
    };
  } catch (error) {
    throw error;
  }
};
